import apiZervant from '../../utils/apiZervant'
import { ResolvedZervantDocument } from './types/resolvedZervantDocument'

/** Answers 404 when no issued invoice, credit note or import of the company was booked under `billyId`. */
export const resolveZervantDocument = (billyId: string) =>
  apiZervant.restInvoice.get<ResolvedZervantDocument>(`/v1/external/documents/resolve/${billyId}`)
